var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconRealEstateDimensionsBuildingRuler({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 15H16a.5.5 0 0 1 .5.5v7.75h0-6.75 0V15.5a.5.5 0 0 1 .5-.5Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23.25h5.25v-12a.75.75 0 0 0-.75-.75h-6.75a.75.75 0 0 0-.75.75V15m-3.75 8.25h-1.5m15 0h-1.5M13.5 18h3m3-3h2.25m-2.25 3h2.25m-2.25-7.5V8.25",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 1.5a.75.75 0 0 0-.75-.75h-21a.75.75 0 0 0-.75.75v21a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75V5.25H22.5a.75.75 0 0 0 .75-.75Zm-19.5 9.75h1.5m-1.5 6h1.5m6-12v-1.5m6 1.5v-1.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.75 5.25h4.5V.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconRealEstateDimensionsBuildingRuler);
export default __webpack_public_path__ + "static/media/streamline-icon-real-estate-dimensions-building-ruler.8326712d.svg";
export { ForwardRef as ReactComponent };